import {
    FETCH_LETTER_RELATION,
    FETCH_LETTER_RELATION_SUCCESS
  } from "constants/ActionTypes";
  
  const INIT_STATE = {
    loader: true,
    letterRelations: null,
    letterRelationParams: null
  };
  
  export default (state = INIT_STATE, action) => {
    switch (action.type) {
      case FETCH_LETTER_RELATION: {
        return {
          ...state,
          loader: true,
          letterRelationParams: action.payload
        };
      }
      case FETCH_LETTER_RELATION_SUCCESS: {
        return {
          ...state,
          loader: false,
          letterRelations: action.payload
        };
      }
      default:
        return state;
    }
  };
  